import isEmpty from 'lodash/isEmpty';
import { Redirect, Route } from 'react-router-dom';
import { determineIfAllowedScopes, Permissions } from '@cowbell/data';
import { useScopes } from './useScopes';
import withRouter from './withRouter';

interface ProtectedRouteProps {
  readonly component: React.ComponentType<any>;
  readonly requiredScope?: Permissions[] | 'any' | 'none';
  readonly requiredQueryParams?: Record<string, string>;
  readonly rqps?: Record<string, string>;
  readonly fallbackPath?: string;
  readonly [key: string]: unknown;
}

const ProtectedRouteBase = ({
  component: Component,
  requiredScope,
  requiredQueryParams,
  rqps,
  fallbackPath = '/',
  ...rest
}: ProtectedRouteProps) => {
  const scopes = useScopes();
  const isAllowed = determineIfAllowedScopes(scopes, requiredScope ?? [], true);

  if (isEmpty(scopes) || !isAllowed) {
    return <Route {...rest} render={() => <Redirect to={fallbackPath} />} />;
  }

  return (
    <Route
      {...rest}
      render={(props) => (
        <Component
          {...props}
          requiredQueryParams={requiredQueryParams}
          rqps={requiredQueryParams ?? rqps}
        />
      )}
    />
  );
};

export const ProtectedRoute = withRouter(ProtectedRouteBase);
